export class Controller {

    /** @ngInject */
    constructor($rootScope, $state, Alert, DirectoriesResource) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.Alert = Alert;
        this.DirectoriesResource = DirectoriesResource;
    }

    $onInit() {
        this.$model = this.modelFromDto();
        this.model = this.modelFromDto();
    }

    cancel() {
        this.$onInit();
    }

    modelFromDto() {
        return {
            upnSuffixes: this.directory.upnSuffixes,
        };
    }

    modelToDto() {
        return {...this.directory, ...this.model};
    }

    save() {
        this.isSaving = true;
        this.DirectoriesResource
            .updateDirectory(this.companyId, this.modelToDto())
            .then(() => {
                this.Alert('success', 'company.directory-integration.manage.configuration.updated');
                Object.assign(this.directory, this.model);
                this.$onInit();
            })
            .finally(() => this.isSaving = false)
    }

    validUpnSuffixes() {
        const pattern = this.$rootScope.activeDirectoryDomainPattern;
        return this.model.upnSuffixes.every((domain) => pattern.test(domain));
    }

    notModified() {
        return angular.equals(this.$model, this.model);
    }

    saveDisabled(form) {
        return form.$invalid || this.isSaving || !this.validUpnSuffixes() || this.notModified();
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/domains/configuration/directory-manage-configuration.controller.js